import { observer } from 'mobx-react-lite';

import { api } from '@/api';
import { getAllowedFormFields } from '@/components/generic-form/utils';
import { DrawerFormWithNote } from '@/components/note-form';
import { PERMISSION_OBJ_PRODUCT } from '@/constants/permissions';
import { productStore } from '@/stores';
import { NoteObjectType } from '@/types/enums';
import { getTranslatedString } from '@/utils';
import { withoutRepeatValue } from '@/utils/controller';

import { getFormFields } from './setup';

const entity = 'products';
const store = productStore;

export const ProductForm = observer(({ transition }: any) => {
  const isCreate = transition.router.globals.current.name === `base-layout.${entity}.create`;
  const { productId } = transition.router.globals.params;
  const foundItem = store.items.find(({ id }: any) => id === +productId);

  const onClose = () => {
    transition.router.stateService.go(`base-layout.${entity}`);
  };

  const initValues = !isCreate && foundItem ? { ...foundItem } : {};

  const title = isCreate
    ? getTranslatedString('products.create-new')
    : getTranslatedString('products.product-number', { 0: productId });

  const formFields = getFormFields();
  const allowedFields = getAllowedFormFields(formFields, isCreate, PERMISSION_OBJ_PRODUCT);

  const resourceController = withoutRepeatValue(initValues, {
    create: (values: any) => api[entity].create(values).source.then(({ data }: any) => store.addItem(data)),
    update: (values: any) =>
      api[entity].update(foundItem.id, values).source.then(({ data }: any) => store.updateItem(data)),
  });

  return (
    <DrawerFormWithNote
      objectType={NoteObjectType.Product}
      resourceId={productId}
      title={title}
      initValues={initValues}
      formFields={allowedFields}
      onClose={onClose}
      resourceController={resourceController}
      loaderCondition={!isCreate && !foundItem}
    />
  );
});
